import React from 'react'
import TopEight from './TopEight'
import PageContainer from './PageContainer'
import AboutMe from './AboutMe'
import ProfileContainer from './ProfileContainer'
import NavBar from './NavBar'

export default function App () {
  return (
    <PageContainer>
      <NavBar />
      <ProfileContainer>
        {/* left column */}
        <div>
          <AboutMe />
        </div>
        {/* right column */}
        <div>
          <TopEight/>
        </div>
      </ProfileContainer>
    </PageContainer>
  )
}
